import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

function ReadMore({
  children,
  additionalInfo,
  showMoreButtonCSS = '',
  showMoreText = '', //if empty, shows chevron icon
  showLessText = '', //if empty, shows chevron icon
  showMoreTextWithIcon = '', //if empty, shows chevron icon
  showLessTextWithIcon = '', //if empty, shows chevron icon
  maxLines = appConstantSettings.SHOW_MORE_MAX_LINES,
  enableTrim = true,
  className
}) {
  const { t } = useTranslation()
  const ref = useRef(null)
  const [showToggle, setShowToggle] = useState(false)
  const [isTextClamped, setIsTextClamped] = useState(true)
  //this useeffects calls first. it checks whether to show "show more" UI if lines or chars exceeded.
  useEffect(() => {
    let tempDiv = null
    if (enableTrim && children && children.length > 0) {
      const scrollHeight = ref?.current?.scrollHeight
      const clientHeight = ref?.current?.clientHeight
      const isClamped = scrollHeight > clientHeight
      setIsTextClamped(isClamped)
      setShowToggle(isClamped)
    }
  }, [children])

  const toggleReadMore = (e) => {
    e.stopPropagation()
    setIsTextClamped(!isTextClamped)
  }

  return (
    <p className={`${styles.text} ${className}`}>
      <span
        ref={ref}
        className={`${isTextClamped ? `${styles.content} ${enableTrim && styles[`content${maxLines}Lines`]}` : ''}`}
        dangerouslySetInnerHTML={{ __html: children }}
      />
      {additionalInfo && <span dangerouslySetInnerHTML={{ __html: additionalInfo }}></span>}
      {children && children.length > 0
        ? showToggle && (
            <button
              aria-label={isTextClamped ? t('global.seeMore') : t('global.seeLess')}
              onClick={toggleReadMore}
              className={`${styles.readOrHide} ${showMoreText && styles.showMoreButton} ${showMoreButtonCSS}`}>
              {isTextClamped ? (
                showMoreTextWithIcon ? (
                  <React.Fragment>
                    <span>{showMoreTextWithIcon}</span>
                    <Icon styleModifier={styles.showMoreIcon} name='chevron-down24' />
                  </React.Fragment>
                ) : showMoreText ? (
                  <span>{showMoreText}</span>
                ) : (
                  <Icon styleModifier={styles.showMoreIcon} name='chevron-down24' />
                )
              ) : showLessTextWithIcon ? (
                <React.Fragment>
                  <span>{showLessTextWithIcon}</span>
                  <Icon styleModifier={styles.showMoreIcon} name='chevron-up24' />
                </React.Fragment>
              ) : showLessText ? (
                <span>{showLessText}</span>
              ) : (
                <Icon styleModifier={styles.showMoreIcon} name='chevron-up24' />
              )}
            </button>
          )
        : null}
    </p>
  )
}

export default ReadMore
